const FETCH_POSTINGS = 'avisos/posting/FETCH_POSTINGS';
const FETCH_POSTINGS_COMPLETED = 'avisos/posting/FETCH_POSTINGS_COMPLETED';
const FETCH_POSTINGS_FAILED = 'avisos/posting/FETCH_POSTINGS_FAILED';
const RESET_POSTINGS = 'avisos/postings/RESET_POSTINGS';
const UPDATE_POSTING = 'avisos/posting/UPDATE_POSTING';
const CHECK_DRAFT_IS_COMPLETE = 'avisos/posting/CHECK_DRAFT_IS_COMPLETE';
const CHECK_DRAFT_IS_COMPLETE_COMPLETED = 'avisos/posting/CHECK_DRAFT_IS_COMPLETE_COMPLETED';
const CHECK_DRAFT_IS_COMPLETE_FAILED = 'avisos/posting/CHECK_DRAFT_IS_COMPLETE_FAILED';
const FETCH_VISITS = 'avisos/posting/FETCH_VISITS';
const FETCH_VISITS_COMPLETED = 'avisos/posting/FETCH_VISITS_COMPLETED';
const FETCH_VISITS_FAILED = 'avisos/posting/FETCH_VISITS_FAILED';
const FETCH_QUALITY = 'avisos/posting/FETCH_QUALITY';
const FETCH_QUALITY_COMPLETED = 'avisos/posting/FETCH_QUALITY_COMPLETED';
const FETCH_QUALITY_FAILED = 'avisos/posting/FETCH_QUALITY_FAILED';
const FETCH_LEADS = 'avisos/posting/FETCH_LEADS';
const FETCH_LEADS_COMPLETED = 'avisos/posting/FETCH_LEADS_COMPLETED';
const FETCH_LEADS_FAILED = 'avisos/posting/FETCH_LEADS_FAILED';
const REMOVE_ONE_POST = 'avisos/posting/REMOVE_ONE_POST';
const DUPLICATE_POST = 'avisos/posting/DUPLICATE_POST';
const DUPLICATE_POST_COMPLETED = 'avisos/posting/DUPLICATE_POST_COMPLETED';
const DUPLICATE_POST_FAILED = 'avisos/posting/DUPLICATE_POST_FAILED';
const FETCH_PERFORMANCE_STATUS = 'avisos/posting/PERFORMANCE_STATUS';
const FETCH_PERFORMANCE_STATUS_COMPLETED = 'avisos/posting/PERFORMANCE_STATUS_COMPLETED';
const FETCH_PERFORMANCE_STATUS_FAILED = 'avisos/posting/PERFORMANCE_STATUS_FAILED';
const CHECK_POSTING = 'avisos/posting/CHECK_POSTING';
const FETCH_REPORTS = 'avisos/posting/FETCH_REPORTS';
const FETCH_REPORTS_COMPLETED = 'avisos/posting/FETCH_REPORTS_COMPLETED';
const FETCH_REPORTS_ERROR = 'avisos/posting/FETCH_REPORTS_ERROR';
const GET_SOCIAL_ADS_REPORT = 'avisos/posting/GET_SOCIAL_ADS_REPORT';
const GET_SOCIAL_ADS_REPORT_COMPLETED = 'avisos/posting/GET_SOCIAL_ADS_REPORT_COMPLETED';
const CHECK_POSTING_REPORT = 'avisos/posting/CHECK_POSTING_REPORT';
const POSTING_VIEWS_STATS = 'avisos/posting/POSTING_VIEWS_STATS';
const POSTING_VIEWS_STATS_COMPLETED = 'avisos/posting/POSTING_VIEWS_STATS_COMPLETED';
const POSTING_VIEWS_STATS_FAILED = 'avisos/posting/POSTING_VIEWS_STATS_FAILED';
const GET_POSTING_LOGS = 'avisos/posting/GET_POSTING_LOGS';
const GET_POSTING_LOGS_COMPLETED = 'avisos/posting/GET_POSTING_LOGS_COMPLETED';
const GET_POSTING_LOGS_FAILED = 'avisos/posting/GET_POSTING_LOGS_FAILED';
const GET_DASHBOARD_INFO = 'avisos/posting/GET_DASHBOARD_INFO';
const GET_DASHBOARD_INFO_COMPLETED = 'avisos/posting/GET_DASHBOARD_INFO_COMPLETED';
const GET_DASHBOARD_INFO_FAILED = 'avisos/posting/GET_DASHBOARD_INFO_FAILED';
const CHECK_OUTDATED_COMPANY = 'avisos/posting/CHECK_OUTDATED_COMPANY';
const GET_FINISH_REASON = 'avisos/posting/GET_FINISH_REASON';
const GET_FINISH_REASON_COMPLETED = 'avisos/posting/GET_FINISH_REASON_COMPLETED';
const GET_FINISH_REASON_FAILED = 'avisos/posting/GET_FINISH_REASON_FAILED';
const GET_FINISH_REASON_BY_POSTING = 'avisos/posting/GET_FINISH_REASON_BY_POSTING';
const GET_FINISH_REASON_BY_POSTING_COMPLETED = 'avisos/posting/GET_FINISH_REASON_BY_POSTING_COMPLETED';
const GET_FINISH_REASON_BY_POSTING_FAILED = 'avisos/posting/GET_FINISH_REASON_BY_POSTING_FAILED';
const FETCH_POSTINGS_QUALITY_TO_EXPORT = 'avisos/postings/FETCH_POSTINGS_QUALITY_TO_EXPORT';
const FETCH_POSTINGS_QUALITY_TO_EXPORT_COMPLETED = 'avisos/postings/FETCH_POSTINGS_QUALITY_TO_EXPORT_COMPLETED';
const FETCH_POSTINGS_QUALITY_TO_EXPORT_FAILED = 'avisos/postings/FETCH_POSTINGS_QUALITY_TO_EXPORT';
const RESET_POSTINGS_QUALITY_TO_EXPORT = 'avisos/postings/RESET_POSTINGS_QUALITY_TO_EXPORT';

export {
  CHECK_DRAFT_IS_COMPLETE,
  CHECK_DRAFT_IS_COMPLETE_COMPLETED,
  CHECK_DRAFT_IS_COMPLETE_FAILED,
  FETCH_POSTINGS,
  FETCH_POSTINGS_COMPLETED,
  FETCH_POSTINGS_FAILED,
  RESET_POSTINGS,
  UPDATE_POSTING,
  FETCH_VISITS,
  FETCH_VISITS_COMPLETED,
  FETCH_VISITS_FAILED,
  FETCH_QUALITY,
  FETCH_QUALITY_COMPLETED,
  FETCH_QUALITY_FAILED,
  FETCH_LEADS,
  FETCH_LEADS_COMPLETED,
  FETCH_LEADS_FAILED,
  REMOVE_ONE_POST,
  DUPLICATE_POST,
  DUPLICATE_POST_COMPLETED,
  DUPLICATE_POST_FAILED,
  FETCH_PERFORMANCE_STATUS,
  FETCH_PERFORMANCE_STATUS_COMPLETED,
  FETCH_PERFORMANCE_STATUS_FAILED,
  CHECK_POSTING,
  FETCH_REPORTS,
  FETCH_REPORTS_COMPLETED,
  FETCH_REPORTS_ERROR,
  GET_SOCIAL_ADS_REPORT,
  GET_SOCIAL_ADS_REPORT_COMPLETED,
  CHECK_POSTING_REPORT,
  POSTING_VIEWS_STATS,
  POSTING_VIEWS_STATS_COMPLETED,
  POSTING_VIEWS_STATS_FAILED,
  GET_POSTING_LOGS,
  GET_POSTING_LOGS_COMPLETED,
  GET_POSTING_LOGS_FAILED,
  GET_DASHBOARD_INFO,
  GET_DASHBOARD_INFO_COMPLETED,
  GET_DASHBOARD_INFO_FAILED,
  GET_FINISH_REASON,
  GET_FINISH_REASON_COMPLETED,
  GET_FINISH_REASON_FAILED,
  CHECK_OUTDATED_COMPANY,
  GET_FINISH_REASON_BY_POSTING,
  GET_FINISH_REASON_BY_POSTING_COMPLETED,
  GET_FINISH_REASON_BY_POSTING_FAILED,
  FETCH_POSTINGS_QUALITY_TO_EXPORT,
  FETCH_POSTINGS_QUALITY_TO_EXPORT_COMPLETED,
  FETCH_POSTINGS_QUALITY_TO_EXPORT_FAILED,
  RESET_POSTINGS_QUALITY_TO_EXPORT
};
